import { getPageAllowedRoles } from "../../config/roles";
import { fullWidth } from "../../blocks/layout/columnSpans";
import { PageDefinition } from "../pageDefinition.types";
import JourneyPlannerCanvasPanel from "./JourneyPlannerCanvasPanel";
import JourneyPlannerFooter from "./JourneyPlannerFooter";
import JourneyPlannerNewJourneyButton from "./JourneyPlannerNewJourneyButton";
import JourneyPlannerShell from "./JourneyPlannerShell";
import JourneyPlannerSidebar from "./JourneyPlannerSidebar";
import JourneyPlannerZoomControls from "./JourneyPlannerZoomControls";

/** Automations dragged onto journeys on a zoomable canvas; the shell shares the planner's state with the bar and dock. */
export const journeyPlannerPageDefinition: PageDefinition = {
  path: "/journey-planner",
  title: "Journey Planner",
  allowedRoles: getPageAllowedRoles("journey-planner"),
  provider: JourneyPlannerShell,
  headerCentre: JourneyPlannerZoomControls,
  headerActions: JourneyPlannerNewJourneyButton,
  dock: {
    label: "automations",
    width: 400,
    component: JourneyPlannerSidebar,
  },
  footer: JourneyPlannerFooter,
  fill: true,
  rows: [
    {
      id: "row-planner",
      panels: [
        {
          id: "panel-planner",
          title: "",
          span: fullWidth,
          component: JourneyPlannerCanvasPanel,
          plain: true,
        },
      ],
    },
  ],
};
